"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var qs = require("qs");
var lodash_1 = require("lodash");
var location_util_1 = require("../../shared/location_util");
var api_request_1 = require("../../api_request");
var suggestion_1 = require("./suggestion");
var suggestion_collection_1 = require("./suggestion_collection");
var collection_header_store_1 = require("../stores/collection_header_store");
var site_search_1 = require("./site_search");
var url_helpers_1 = require("../../shared/url_helpers");
var site_search_suggestion_1 = require("./site_search_suggestion");
var MAX_MAIN_RESULTS = 5;
var MAX_SUB_RESULTS = 2;
var CURATED_SET_TYPE = 'curated_set';
function buildRecentSearches(searches) {
    if (searches.length === 0) {
        return new suggestion_collection_1.default([]);
    }
    var results = searches.map(function (value, idx) {
        return new suggestion_1.default({ value: value, type: site_search_1.RECENT_SEARCH, position: idx }, site_search_suggestion_1.default);
    });
    return new suggestion_collection_1.default([{
            results: results,
            heading: I18n.t('discovery.autocomplete.recentSearches'),
        }]);
}
exports.buildRecentSearches = buildRecentSearches;
function addCurrentPageSuggestion(suggestions, query) {
    var collectionHeader = collection_header_store_1.CollectionHeaderStore.getState().collectionHeader;
    if (!collectionHeader ||
        (!location_util_1.default.isOnHandpickedPage() && !location_util_1.default.isOnSalePage())) {
        return;
    }
    var _a = window.location, pathname = _a.pathname, search = _a.search, origin = _a.origin;
    var currentQueryParams = qs.parse(search.slice(1));
    var params = qs.stringify(tslib_1.__assign(tslib_1.__assign({}, currentQueryParams), { query: query }));
    var url = "" + origin + pathname + "?" + params;
    suggestions.unshift(new suggestion_1.default({
        url: url,
        filter_value: collectionHeader.title,
        filters: [],
        params: {},
        type: 'currentPage',
        value: query,
    }, site_search_suggestion_1.default));
}
exports.addCurrentPageSuggestion = addCurrentPageSuggestion;
function setPositions(suggestions, offset) {
    suggestions.forEach(function (s, idx) { s.position = idx + offset; });
}
function buildSuggestions(suggestions, query) {
    var allSuggestions = suggestions.reduce(function (all, suggestion) { return all.concat(new suggestion_1.default(suggestion, site_search_suggestion_1.default).filters); }, []);
    var mainSuggestions = lodash_1.filter(allSuggestions, function (suggestion) { return ((suggestion.type !== CURATED_SET_TYPE)); }).slice(0, MAX_MAIN_RESULTS);
    addCurrentPageSuggestion(mainSuggestions, query);
    var subSuggestions = lodash_1.filter(allSuggestions, function (s) { return (s.type === CURATED_SET_TYPE); })
        .slice(0, MAX_SUB_RESULTS);
    setPositions(mainSuggestions, 0);
    setPositions(subSuggestions, mainSuggestions.length);
    var suggestionGroups = [
        {
            heading: null,
            results: mainSuggestions,
        },
        {
            heading: I18n.t('discovery.searchBar.context.handpickedCollections'),
            results: subSuggestions,
        },
    ].filter(function (group) { return group.results.length; });
    return new suggestion_collection_1.default(suggestionGroups);
}
exports.buildSuggestions = buildSuggestions;
var ReverbSiteSearchSuggestions = /** @class */ (function () {
    function ReverbSiteSearchSuggestions() {
    }
    ReverbSiteSearchSuggestions.fetch = function (query) {
        return api_request_1.V3.get(url_helpers_1.default.autocompletePath(query)).then(function (suggestions) {
            return buildSuggestions(suggestions, query);
        });
    };
    return ReverbSiteSearchSuggestions;
}());
exports.default = ReverbSiteSearchSuggestions;
//# sourceMappingURL=reverb_site_search_suggestions.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/site_search/reverb_site_search_suggestions.js
// module id = 7A/r
// module chunks = 20 21